import React, {Component} from 'react';
import PropTypes from 'prop-types';
import Wrapper from '../../components/wrapper';
import './styles.css';
import Accordion from "../../components/accordion";

/**
 *  MakerSetOptionMoreInfoItem
 */
class MakerSetOptionMoreInfoItem extends Component {
  static propTypes = {
    containerId: PropTypes.string,
    containerClass: PropTypes.string,
    anchorPoint: PropTypes.string,
    anchorName: PropTypes.string,
    name: PropTypes.string,
    items: PropTypes.string,
    makerSetOptionImageSrc: PropTypes.string,
    mbMakerSetOptionImageSrc: PropTypes.string,
    detailLinkLabel: PropTypes.string,
    detail: PropTypes.string,
    mbDetail: PropTypes.string,
    openModalWindow: PropTypes.func,
  };
  static defaultProps = {
    containerId: null,
    containerClass: null,
    anchorPoint: null,
    anchorName: null,
    name: null,
    items: null,
    makerSetOptionImageSrc: null,
    mbMakerSetOptionImageSrc: null,
    detailLinkLabel: null,
    detail: null,
    mbDetail: null,
    openModalWindow: null,
  };
  
  constructor(props) {
    super();
    this.props = props;
    this.state = {
      wrapHeight: 'auto',
      isHidden: true,
      isOpened: false,
    };
  }
  
  render() {
    
    const getPcImage = ()=> {
      if (this.props.makerSetOptionImageSrc && this.props.makerSetOptionImageSrc !== '') {
        return this.props.makerSetOptionImageSrc;
      } else {
        return null;
      }
    };
    
    const getMbImage = ()=> {
      if (this.props.mbMakerSetOptionImageSrc && this.props.mbMakerSetOptionImageSrc !== '') {
        return this.props.mbMakerSetOptionImageSrc;
      } else {
        return getPcImage();
      }
    };
    
    const getDetailPc = () => {
      if (this.props.detail && this.props.detail !== '') {
        return this.props.detail;
      } else {
        return null;
      }
    };
    
    const getDetailMb = () => {
      if (this.props.mbDetail && this.props.mbDetail !== '') {
        return this.props.mbDetail;
      } else {
        return getDetailPc();
      }
    };
  
    // 画像
    const renderImage = ()=> {
      if (getPcImage()) {
        return (
          <div className="MakerSetOptionMoreInfoItem__image">
            <div className="MakerSetOptionMoreInfoItem__image__box">
              <img className="MakerSetOptionMoreInfoItem__image-pc" src={getPcImage()} alt=""/>
            </div>
            <img className="MakerSetOptionMoreInfoItem__image-mb" src={getMbImage()} alt=""/>
          </div>
        )
      } else {
        return null;
      }
    };
  
    // アイテム
    const renderItems = ()=> {
      if (this.props.items && this.props.items !== '') {
        let items = this.props.items;
        items = items.replace(/<br>/g, '|');
        items = items.replace(/<br \/>/g, '|');
        items = items.replace(/<br\/>/g, '|');
        const arr = items.split('|');
        return (
          <div className="MakerSetOptionMoreInfoItem__items">
            <ul className="MakerSetOptionMoreInfoItem__items__list">
              {arr.map((item, index)=> {
                return (
                  <li key={index}>{item}</li>
                )
              })}
            </ul>
          </div>
        );
      } else {
        return null;
      }
    };
    
    // 詳細
    const renderDetail = () => {
      const detail = getDetailPc();
      const detailMb = getDetailMb();
      if (detail && detailMb) {
        return (
          <div className="MakerSetOptionMoreInfoItem__detail">
            <a className="MakerSetOptionMoreInfoItem__detail__link"
               href="javascript:void(0);"
               onClick={(e) => {
                 e.preventDefault();
                 if (this.props.openModalWindow !== null) {
                   this.props.openModalWindow({
                     detail: detail,
                     detailMb: detailMb,
                   });
                 }
               }}
            >
              {(this.props.detailLinkLabel && this.props.detailLinkLabel !== '') ? this.props.detailLinkLabel: null}
            </a>
          </div>
        )
      } else {
        return (
          null
        )
      }
    };
  
    // もっと見る
    const renderMoreInfo = ()=> {
      if (this.state.isHidden === true && this.state.isOpened === false) {
        return (
          <div className="MakerSetOptionMoreInfoItem__more-info">
            <a className="MakerSetOptionMoreInfoItem__more-info__link" href="javascript:void(0);" onClick={(e)=> {
              e.preventDefault();
              //
              this.setState({
                isOpened: true,
              });
            }}>すべて表示</a>
          </div>
        )
      } else {
        return null;
      }
    };
    
    return (
      <Wrapper
        containerId={this.props.containerId}
        containerClass={this.props.containerClass}
        anchorPoint={this.props.anchorPoint}
        anchorName={this.props.anchorName}
      >
        <div className="MakerSetOptionMoreInfoItem" style={(this.state.isOpened === true) ? {height: 'auto'} : {height: this.state.wrapHeight}}>
          <div className="MakerSetOptionMoreInfoItem__container" ref="container">
            <div className="MakerSetOptionMoreInfoItem__container2">
              {(() => {
                if (getMbImage() || (this.props.items && this.props.items !== '') || getDetailMb()) {
                  return (
                    <Accordion
                      pcText={(this.props.name && this.props.name !== '') ? this.props.name : ''}
                      open={false}
                      current={false}
                      simpleAnimation={false}
                    >
                      <div className="MakerSetOptionMoreInfoItem__box">
                        <div ref="image">
                          {renderImage()}
                        </div>
                        {renderItems()}
                        {renderDetail()}
                      </div>
                    </Accordion>
                  )
                } else {
                  return (
                    <div className="Accordion">
                      <div className="Accordion__title">
                        <span className="Accordion__title-pc">{(this.props.name && this.props.name !== '') ? this.props.name : ''}</span>
                        <span className="Accordion__title-mb">{(this.props.name && this.props.name !== '') ? this.props.name : ''}</span>
                      </div>
                    </div>
                  )
                }
              })()}
              {renderMoreInfo()}
            </div>
          </div>
        </div>
      </Wrapper>
    )
  }
  
  // 高さ取得
  getHeight = ()=> {
    if (this.props.makerSetOptionImageSrc && this.props.makerSetOptionImageSrc !== '') {
      const titleHeight = this.refs.container.getElementsByClassName('Accordion__title')[0].clientHeight;
      const imageHeight = this.refs.image.clientHeight;
      return titleHeight + imageHeight + 75;
    } else {
      return 240;
    }
  };
  
  // 高さ設定
  setHeight = (height)=> {
    height = Math.floor(height);
    if (height < this.refs.container.clientHeight) {
      this.setState({
        wrapHeight: height,
        isHidden: true,
      });
    } else {
      this.setState({
        wrapHeight: height,
        isHidden: false,
      });
    }
  };
  
}

export default MakerSetOptionMoreInfoItem;



// WEBPACK FOOTER //
// ./src/containers/maker-set-option-more-info-item/index.jsx